import React, { useCallback, useEffect, useRef, useState } from 'react';
import { TextBox, Button as TextBoxButton } from 'devextreme-react/text-box';
import { LoadPanel } from 'devextreme-react/load-panel';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import ValidationGroup from 'devextreme-react/validation-group';
import Validator, { RequiredRule, EmailRule, AsyncRule, StringLengthRule, PatternRule, CompareRule } from 'devextreme-react/validator';

import Button from 'devextreme-react/button';
// import CheckBox from 'devextreme-react/check-box';
import './index.scss';
import { Link } from 'react-router-dom';
import cs from '../../utils/const.js';
import AntString from '../../utils/AntString.js';
import AntLocalization from '../../utils/AntLocalization.js';
import AntAuth from '../../utils/AntAuth';
import AntBusiness from '../../utils/AntBusiness';
import AntErrorPanel from '../AntErrorPanel';
import AntCardLayout from '../AntCardLayout';
import AntTitlePanel from '../AntTitlePanel';
import AntDescPanel from '../AntDescPanel';
import md5 from 'md5';

import { AntGlobal, AntSessionContext } from '../../utils/AntContext';

export default function (props) {
    const appGlobal = AntGlobal();

    const [busShortCode, setBusShortCode] = useState(cs.Business_Short_Code ? cs.Business_Short_Code : '');

    const hasBusShortCode = Boolean(cs.Business_Short_Code);
    const isWhiteLabel = Boolean(cs.Is_White_Label);
    const [errorText, setErrorText] = useState('');
    const [oldPassword, setOldPassword] = useState('');
    const [password1, setPassword1] = useState('');
    const [password2, setPassword2] = useState('');
    const [processing, setProcessing] = useState(false);

    const validationGroup = useRef();
    const txtPasswordOld = useRef();
    const txtPassword1 = useRef();
    const txtPassword2 = useRef();

    const { appInfo, appAssets } = appGlobal;
    var title = appInfo && appInfo.title ? appInfo.title : '';
    var logoOnly = appAssets && appAssets.images.logoOnly ? appAssets.images.logoOnly : undefined;
    var logoWithBrand = appAssets && appAssets.images.logoWithBrandSlogun ? appAssets.images.logoWithBrandSlogun : undefined;
    var loginBackground = appAssets && appAssets.images.loginBackground ? appAssets.images.loginBackground : undefined;

    const sesionInfo = AntAuth.getSessionInfo();
    // Tài khoản chưa đặt mật khẩu (đăng ký không đặt mật khẩu): không hỏi mật khẩu cũ.
    const noPassword = Boolean(sesionInfo && sesionInfo.no_password);

    const resetPassword = () => {
        if (validationGroup.current && !validationGroup.current.instance.validate().isValid) {
            return;
        }

        setErrorText(null);
        setProcessing(true);

        AntAuth.resetPassword(
            {
                old_password: noPassword ? undefined : md5(AntString.clean(oldPassword)),
                password1: md5(AntString.clean(password1)),
                password2: md5(AntString.clean(password2))
            },
            (res) => {
                if (res && res.error) {
                    setErrorText(res.error);
                    setProcessing(false);
                } else {
                    if (props.onDone) props.onDone(res);
                    // this.setState({
                    //     processing: false
                    // });
                }
                // this.validationGroup.reset();
            }
        );
    };

    // if (processing)
    //     return (
    //         <div>
    //             <LoadPanel
    //                 visible={true}
    //                 showPane={false}
    //                 shading={false}
    //                 shadingColor={'rgba(255, 255, 255, 1)'}
    //                 // indicatorSrc={'https://image.flaticon.com/icons/svg/3305/3305803.svg'}

    //                 className={'login-loading'}
    //             />
    //         </div>
    //     );

    return (
        <div
            style={{
                display: 'block',
                backgroundImage: loginBackground ? `url(${loginBackground})` : undefined,

                width: '100%',
                height: '100%',

                backgroundRepeat: 'no-repeat',
                backgroundAttachment: 'fixed',
                backgroundSize: '100% 100%',

                filter: blur('8px')
            }}
        >
            <div
                style={{
                    visibility: !processing ? 'hidden' : 'visible'
                }}
            >
                <LoadPanel
                    position={{ of: '#root' }}
                    visible={processing}
                    showPane={false}
                    shading={false}
                    // shadingColor={'rgba(255, 255, 255, 1)'}
                    // indicatorSrc={'https://image.flaticon.com/icons/svg/3305/3305803.svg'}

                    wrapperAttr={{
                        class: 'ant-loading'
                    }}
                />
            </div>
            <AntCardLayout
                width={400}
                scale={1.0}
                style={{
                    visibility: processing ? 'hidden' : 'visible'
                }}
                marginLeft={props.marginLeft}
                marginRight={props.marginRight}
            >
                <div>
                    <ValidationGroup ref={validationGroup} className={'login-panel'}>
                        {/* <div className={'login-header'}>
                                {!logoWithBrand && <div className={'title'}>{appInfo.title}</div>}
                                {logoWithBrand && <img src={logoWithBrand} style={{ width: '160px' }} />}
                            </div> */}
                        {!processing && (
                            <div className={'dx-field'}>
                                <AntDescPanel
                                    text={`${AntLocalization.translateText({ vi: 'Vui lòng tạo mật khẩu mới cho tài khoản:', en: 'Please create a new password for account:', fr: 'Créez un nouveau mot de passe pour le compte :', es: 'Cree una nueva contraseña para la cuenta:', id: 'Buat kata sandi baru untuk akun:', ja: 'アカウントの新しいパスワードを作成してください:', zh: '请为账户创建新密码:', ko: '계정의 새 비밀번호를 만들어 주세요:', hi: 'खाते के लिए नया पासवर्ड बनाएँ:', ar: 'يرجى إنشاء كلمة مرور جديدة للحساب:' })} ${sesionInfo.user_code}:`}
                                />
                            </div>
                        )}
                        {!noPassword && (
                        <div className={'dx-field'}>
                            <TextBox
                                ref={txtPasswordOld}
                                mode={'password'}
                                value={oldPassword}
                                placeholder={AntLocalization.translateText({ vi: 'Mật khẩu cũ', en: 'Old password', fr: 'Ancien MDP', es: 'Clave anterior', id: 'Kata sandi lama', ja: '旧パスワード', zh: '旧密码', ko: '이전 비밀번호', hi: 'पुराना पासवर्ड', ar: 'كلمة سر قديمة' })}
                                width={'100%'}
                                className={'login-password'}
                                onValueChanged={(e) => {
                                    setOldPassword(e.value);
                                }}
                                onEnterKey={(e) => {
                                    if (txtPassword1.current && txtPassword1.current.instance) txtPassword1.current.instance.focus();
                                }}
                                onFocusIn={(e) => {
                                    let inputEl = e.element.querySelector('.dx-texteditor-input');
                                    if (inputEl) {
                                        inputEl.selectionStart = 0;
                                        inputEl.selectionEnd = inputEl.value.length;
                                    }
                                }}
                            >
                                <Validator>
                                    <RequiredRule
                                        message={AntLocalization.translateText({ vi: 'Không được trống !', en: 'Cannot be empty!', fr: 'Ne peut pas être vide !', es: '¡No puede estar vacío!', id: 'Tidak boleh kosong!', ja: '空にできません！', zh: '不能为空！', ko: '비워둘 수 없습니다!', hi: 'खाली नहीं हो सकता!', ar: 'لا يمكن أن يكون فارغاً!' })}
                                    />
                                    <StringLengthRule
                                        message={AntLocalization.translateText({ vi: 'Tối đa 64 ký tự', en: 'Maximum 64 characters', fr: '64 caractères maximum', es: 'Máximo 64 caracteres', id: 'Maksimal 64 karakter', ja: '最大64文字', zh: '最多 64 个字符', ko: '최대 64자', hi: 'अधिकतम 64 अक्षर', ar: '64 حرفًا كحد أقصى' })}
                                        max={64}
                                    />
                                </Validator>
                                <TextBoxButton
                                    name="keyCode"
                                    location="before"
                                    options={{
                                        icon: 'key',
                                        stylingMode: 'text',
                                        focusStateEnabled: false,
                                        activeStateEnabled: false,
                                        hoverStateEnabled: false,
                                        type: 'default'
                                    }}
                                />
                            </TextBox>
                        </div>
                        )}
                        <div className={'dx-field'}>
                            <TextBox
                                ref={txtPassword1}
                                mode={'password'}
                                value={password1}
                                placeholder={AntLocalization.translateText({ vi: 'Mật khẩu mới', en: 'New password', fr: 'New password', es: 'New password', id: 'Kata sandi baru', ja: 'New password', zh: '新密码', ko: '새 비밀번호', hi: 'नया पासवर्ड', ar: 'كلمة مرور جديدة' })}
                                width={'100%'}
                                className={'login-password'}
                                onValueChanged={(e) => {
                                    setPassword1(e.value);
                                }}
                                onEnterKey={(e) => {
                                    if (txtPassword2.current && txtPassword2.current.instance) txtPassword2.current.instance.focus();
                                }}
                                onFocusIn={(e) => {
                                    let inputEl = e.element.querySelector('.dx-texteditor-input');
                                    if (inputEl) {
                                        inputEl.selectionStart = 0;
                                        inputEl.selectionEnd = inputEl.value.length;
                                    }
                                }}
                            >
                                <Validator>
                                    <RequiredRule
                                        message={AntLocalization.translateText({ vi: 'Không được trống !', en: 'Cannot be empty!', fr: 'Ne peut pas être vide !', es: '¡No puede estar vacío!', id: 'Tidak boleh kosong!', ja: '空にできません！', zh: '不能为空！', ko: '비워둘 수 없습니다!', hi: 'खाली नहीं हो सकता!', ar: 'لا يمكن أن يكون فارغاً!' })}
                                    />
                                    <StringLengthRule
                                        message={AntLocalization.translateText({ vi: 'Tối thiểu 6 ký tự', en: 'Minimum 6 characters', fr: '6 caractères minimum', es: 'Mínimo 6 caracteres', id: 'Minimal 6 karakter', ja: '最小6文字', zh: '至少 6 个字符', ko: '최소 6자', hi: 'न्यूनतम 6 अक्षर', ar: '6 أحرف على الأقل' })}
                                        min={6}
                                    />
                                    <StringLengthRule
                                        message={AntLocalization.translateText({ vi: 'Tối đa 64 ký tự', en: 'Maximum 64 characters', fr: '64 caractères maximum', es: 'Máximo 64 caracteres', id: 'Maksimal 64 karakter', ja: '最大64文字', zh: '最多 64 个字符', ko: '최대 64자', hi: 'अधिकतम 64 अक्षर', ar: '64 حرفًا كحد أقصى' })}
                                        max={64}
                                    />
                                </Validator>
                                <TextBoxButton
                                    name="keyCode"
                                    location="before"
                                    options={{
                                        icon: 'key',
                                        stylingMode: 'text',
                                        focusStateEnabled: false,
                                        activeStateEnabled: false,
                                        hoverStateEnabled: false,
                                        type: 'default'
                                    }}
                                />
                            </TextBox>
                        </div>
                        <div className={'dx-field'}>
                            <TextBox
                                ref={txtPassword2}
                                mode={'password'}
                                value={password2}
                                placeholder={AntLocalization.translateText({ vi: 'Nhập lại', en: 'Re-enter', fr: 'Ressaisir', es: 'Repetir', id: 'Ulangi', ja: '再入力', zh: '再次输入', ko: '다시 입력', hi: 'फिर दर्ज करें', ar: 'أعد الإدخال' })}
                                width={'100%'}
                                className={'login-password'}
                                onValueChanged={(e) => {
                                    setPassword2(e.value);
                                }}
                                onEnterKey={resetPassword}
                                onFocusIn={(e) => {
                                    let inputEl = e.element.querySelector('.dx-texteditor-input');
                                    if (inputEl) {
                                        inputEl.selectionStart = 0;
                                        inputEl.selectionEnd = inputEl.value.length;
                                    }
                                }}
                            >
                                <Validator>
                                    <RequiredRule
                                        message={AntLocalization.translateText({ vi: 'Không được trống !', en: 'Cannot be empty!', fr: 'Ne peut pas être vide !', es: '¡No puede estar vacío!', id: 'Tidak boleh kosong!', ja: '空にできません！', zh: '不能为空！', ko: '비워둘 수 없습니다!', hi: 'खाली नहीं हो सकता!', ar: 'لا يمكن أن يكون فارغاً!' })}
                                    />
                                    <StringLengthRule
                                        message={AntLocalization.translateText({ vi: 'Tối thiểu 6 ký tự', en: 'Minimum 6 characters', fr: '6 caractères minimum', es: 'Mínimo 6 caracteres', id: 'Minimal 6 karakter', ja: '最小6文字', zh: '至少 6 个字符', ko: '최소 6자', hi: 'न्यूनतम 6 अक्षर', ar: '6 أحرف على الأقل' })}
                                        min={6}
                                    />
                                    <StringLengthRule
                                        message={AntLocalization.translateText({ vi: 'Tối đa 64 ký tự', en: 'Maximum 64 characters', fr: '64 caractères maximum', es: 'Máximo 64 caracteres', id: 'Maksimal 64 karakter', ja: '最大64文字', zh: '最多 64 个字符', ko: '최대 64자', hi: 'अधिकतम 64 अक्षर', ar: '64 حرفًا كحد أقصى' })}
                                        max={64}
                                    />
                                    <CompareRule
                                        message={AntLocalization.translateText({ vi: 'Mật khẩu mới không khớp !', en: 'New password does not match!', fr: 'Les mots de passe diffèrent !', es: '¡La nueva contraseña no coincide!', id: 'Kata sandi baru tidak cocok!', ja: '新しいパスワードが一致しません!', zh: '新密码不一致!', ko: '새 비밀번호가 일치하지 않습니다!', hi: 'नया पासवर्ड मेल नहीं खाता!', ar: 'كلمة المرور الجديدة غير متطابقة!' })}
                                        comparisonTarget={() => {
                                            return password1;
                                        }}
                                    />
                                </Validator>
                                <TextBoxButton
                                    name="keyCode"
                                    location="before"
                                    options={{
                                        icon: 'key',
                                        stylingMode: 'text',
                                        focusStateEnabled: false,
                                        activeStateEnabled: false,
                                        hoverStateEnabled: false,
                                        type: 'default'
                                    }}
                                />
                            </TextBox>
                        </div>
                        <div className={'dx-field'}>
                            <Button
                                type={'default'}
                                text={
                                    noPassword
                                        ? AntLocalization.translateText({ vi: 'ĐẶT MẬT KHẨU', en: 'SET PASSWORD', fr: 'DÉFINIR', es: 'ESTABLECER', id: 'ATUR KATA SANDI', ja: 'パスワードを設定', zh: '设置密码', ko: '비밀번호 설정', hi: 'पासवर्ड सेट करें', ar: 'تعيين كلمة المرور' })
                                        : AntLocalization.translateText({ vi: 'ĐỔI MẬT KHẨU', en: 'CHANGE PASSWORD', fr: 'MODIFIER', es: 'CAMBIAR CONTRASEÑA', id: 'UBAH KATA SANDI', ja: 'パスワード変更', zh: '更改密码', ko: '비밀번호 변경', hi: 'पासवर्ड बदलें', ar: 'تغيير كلمة المرور' })
                                }
                                onClick={resetPassword}
                                width={'100%'}
                                style={{ fontWeight: 500 }}
                            />
                        </div>
                    </ValidationGroup>
                    <div className={'dx-field'} style={{ marginLeft: '-18px', visibility: !errorText ? 'hidden' : 'visible' }}>
                        <AntErrorPanel text={errorText} />
                    </div>
                    <div>
                        <div className={'dx-field'}>
                            {props.onCancel ? (
                                <Link onClick={props.onCancel}>
                                    {AntLocalization.translateText({ vi: 'Quay lại', en: 'Back', fr: 'Retour', es: 'Volver', id: 'Kembali', ja: '戻る', zh: '返回', ko: '뒤로', hi: 'वापस', ar: 'رجوع' })}
                                </Link>
                            ) : (
                                <Link onClick={AntAuth.logOut}>
                                    {AntLocalization.translateText({ vi: 'Đăng nhập', en: 'Log in', fr: 'Connexion', es: 'Acceder', id: 'Masuk', ja: 'ログイン', zh: '登录', ko: '로그인', hi: 'लॉग इन', ar: 'تسجيل الدخول' })}
                                </Link>
                            )}
                        </div>
                    </div>
                </div>
            </AntCardLayout>
        </div>
    );
}
